module.exports = __webpack_public_path__ + "img/23_100.f821283e.png";